import { Action, Dispatch } from "redux";
import { fetchDeletedResponses, IDeletedRequestParams } from "./Operations";
import { AuthState } from "@okta/okta-auth-js";
import { Action as AnyAction } from "@reduxjs/toolkit";

export enum DeletedResponseActionTypes {
  FetchDeletedResponsesPending = "FETCH_DELETED_RESPONSES_PENDING",
  FetchedDeletedResponses = "FETCHED_DELETED_RESPONSES",
  FetchDeletedResponsesRejected = "FETCH_DELETED_RESPONSES_REJECTED",
  SetSortOrder = "SET_DELETED_SORT_ORDER",
  ResetSortOrder = "RESET_DELETED_SORT_ORDER",
  SetFilter = "SET_DELETED_FILTER",
  ClearFilter = "CLEAR_DELETED_FILTER",
  ClearAllFilters = "CLEAR_ALL_DELETED_FILTERS",
}

export class FetchingDeletedResponsesAction implements Action {
  public readonly type = DeletedResponseActionTypes.FetchDeletedResponsesPending;
}

export class FetchedDeletedResponsesAction implements Action {
  public readonly type = DeletedResponseActionTypes.FetchedDeletedResponses;
  constructor(
    public payload: { deletedResponses: Api.IPagedResult<Api.IDeletedResponseListViewModel> }
  ) { }
}

export class FetchDeletedResponsesFailedAction implements Action {
  public readonly type = DeletedResponseActionTypes.FetchDeletedResponsesRejected;
  constructor(public payload: { error: string }) { }
}

export class SetDeletedSortOrderAction implements Action {
  public readonly type = DeletedResponseActionTypes.SetSortOrder;
  constructor(public payload: { orderBy: string }) { }
}

export class ResetDeletedSortOrderAction implements Action {
  public readonly type = DeletedResponseActionTypes.ResetSortOrder;
}

export class SetDeletedFilterAction implements Action {
  public readonly type = DeletedResponseActionTypes.SetFilter;
  constructor(public payload: { field: string; value: any; operator?: string }) { }
}

export class ClearDeletedFilterAction implements Action {
  public readonly type = DeletedResponseActionTypes.ClearFilter;
  constructor(public payload: { field: string }) { }
}

export class ClearAllDeletedFiltersAction implements Action {
  public readonly type = DeletedResponseActionTypes.ClearAllFilters;
}

export type DeletedResponsesAction =
  | FetchingDeletedResponsesAction
  | FetchedDeletedResponsesAction
  | FetchDeletedResponsesFailedAction
  | SetDeletedSortOrderAction
  | ResetDeletedSortOrderAction
  | SetDeletedFilterAction
  | ClearDeletedFilterAction
  | ClearAllDeletedFiltersAction;

export const getDeletedResponseListThunk: (
  auth: AuthState,
  requestParams: IDeletedRequestParams
) => any = (auth, requestParams) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new FetchingDeletedResponsesAction());
    fetchDeletedResponses(auth, requestParams)
      .then((response: Api.IDeletedResponseListResponse) => {
        dispatch(new FetchedDeletedResponsesAction({ deletedResponses: response.responses }));
      })
      .catch((errorResponse: Error) => {
        // tslint:disable-next-line:no-console
        console.error(errorResponse);
        dispatch(new FetchDeletedResponsesFailedAction({ error: errorResponse.message }));
      });
  };
};

export const setDeletedSortOrder: (orderBy: string) => any = (orderBy) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new SetDeletedSortOrderAction({ orderBy }));
  };
};

export const resetDeletedSortOrder: () => any = () => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ResetDeletedSortOrderAction());
  };
};

export const setDeletedFilter: (field: string, value: any, operator?: string) => any = (field, value, operator) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new SetDeletedFilterAction({ field, value, operator }));
  };
};

export const clearDeletedFilter: (field: string) => any = (field) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ClearDeletedFilterAction({ field }));
  };
};

export const clearAllDeletedFilters: () => any = () => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ClearAllDeletedFiltersAction());
  };
};
